import { recoilSelector } from 'common/util/recoil-selector';
import { ComponentsTheme, THEMED_COMPONENT } from '../themes';
import { createStylesGetter } from '../utils';

const prepareUsageGraphStyles = (
  usageGraphTheme: ComponentsTheme[THEMED_COMPONENT.USAGE_GRAPH],
): ComponentsTheme[THEMED_COMPONENT.USAGE_GRAPH] => usageGraphTheme;

export const usageGraphStylesState = recoilSelector({
  key: THEMED_COMPONENT.USAGE_GRAPH,
  get: createStylesGetter(prepareUsageGraphStyles, THEMED_COMPONENT.USAGE_GRAPH),
});
